<div [formGroup]="fileUploadForm" class="file-uploader row">
    <input type="file" (change)="onFileChange($event)" formControlName="file" class="form-control" accept=".pdf">
    <div *ngIf="fileUploadForm.get('file').hasError('required') && fileUploadForm.get('file').touched" class="text-danger">
        File is required!
    </div>
</div>